
import emsTitle from '@/component/base/emsTitle'
import emsBreadcrumb from '@/component/emsBreadcrumb.vue'
import { phoneRegExp, idRegExp } from '@/common/regExp'
export default {
  data() {
    return {
      id: '',
      ruleForm: {
        applyNumber: '',
        producerName: '',
        cardNumber: '',
        status: '',
        opinion: '',
        personList: [],
        boothNumList: []
      },
      rules: {
        producerName: [{ required: true, message: this.$t('constructionPermit.请输入搭建商公司名称'), trigger: ['blur', 'change'] }],
        boothNumList: [{ required: true, message: this.$t('constructionPermit.请输入展位号') }],
        name: [{ required: true, message: ' ', trigger: ['blur', 'change'] }],
        idcard: [{ required: true, pattern: idRegExp, message: ' ', trigger: ['blur', 'change'] }],
        mobile: [{ required: true, pattern: phoneRegExp, message: ' ', trigger: ['blur', 'change'] }]
      },
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      tableLoading: false,
      previewImgs: [],
      exhibitionId: sessionStorage.getItem('exhibitionId'),
      constructionConfig: {},
      loading: false
    }
  },
  methods: {
    getConstructionConfig() {
      return new Promise(reslove => {
        this.$http.get(this.api + `a/api/construction/getConstructionConfig?exhibitionId=${this.exhibitionId}`).then(res => {
          if (res.data.resultCode === 0 || res.data.resultCode === '0') {
            this.constructionConfig = res.data.data
            reslove()
          }
        })
      })
    },
    getDetail() {
      this.loading = true
      this.$http.get(this.api + 'a/api/construction/get?id=' + this.id).then(res => {
        if (res.data.resultCode === 0 || res.data.resultCode === '0') {
          this.ruleForm = res.data.data
          if (res.data.data.boothNum) {
            let boothNumList = []
            const boothNum = res.data.data.boothNum.split(',')
            boothNumList = boothNum.map(booth => {
              return {
                exnum: booth
              }
            })
            this.$set(this.ruleForm, 'boothNumList', boothNumList)
          }
          this.ruleForm.personList.map(item => {
            // constructionPersonImg是回显的图片，id为dataID
            // imageIds为页面中绑定的图片，上传回显删除
            // 1.constructionPersonImg => imageIds
            this.$set(item, 'imageIds', item.imageIds || [])
            item.constructionPersonImg.map(config => {
              // 新增完接着删除再上传，dataID还是初始化的dataID，需要重新渲染upload组件
              this.$set(config, 'relaodUpload', false)
              config.imageList && config.imageList.map(img => {
                this.formatImg(item.imageIds, img, config)
              })
            })
          })
        }
        this.loading = false
      })
    },
    statusColor(status) {
      let color = '#000'
      switch (status) {
        case 'NOT_PASS': color = '#D10100'; break
        default:
          color = '#000'
      }
      return {
        color
      }
    },
    statusName(status) {
      let name = '-'
      switch (status) {
        case 'TO_SUBMIT': name = this.$t('status.待提交'); break
        case 'TO_AUDIT': name = this.$t('status.待审核'); break
        case 'PASS': name = this.$t('status.审核通过'); break
        case 'NOT_PASS': name = this.$t('status.未通过'); break
        case 'CANCEL': name = this.$t('status.已取消'); break
        default:
          name = '-'
      }
      return name
    },
    getImgs(img) {
      return new Promise(reslove => {
        this.$http.get(`${this.api}a/api/image/list?dataId=${img.id || img.dataId}&type=CONSTRUCTION_PERSON`).then(res => {
          if (res.data.resultCode === 0 || res.data.resultCode === '0') {
            reslove(res.data.data.images)
          }
        })
      })
    },
    formatImg(fileList, img, constructionPersonImg) {
      fileList.push({
        id: constructionPersonImg.id,
        personId: constructionPersonImg.personId,
        type: constructionPersonImg.type,
        uid: img.imageId,
        name: `${constructionPersonImg.imageName}/${img.name}`,
        status: 'done',
        url: `${this.api}a/api/image/downloadByimageId?imageId=${img.imageId}`,
        response: {
          resultCode: 0,
          data: {
            dataId: constructionPersonImg.id,
            imageId: img.imageId
          }
        }
      })
    },
    formatImgByAdd(fileList, img, constructionPersonImg) {
      const imageId = img.response && img.response.data && img.response.data.imageId
      const dataId = img.response && img.response.data && img.response.data.dataId
      let name = ''
      if (img.name.indexOf(constructionPersonImg.configName) > -1) {
        name = img.name
      } else {
        name = `${constructionPersonImg.configName}/${img.name}`
      }
      fileList.push({
        id: dataId,
        type: constructionPersonImg.configValue,
        uid: imageId,
        name: name,
        status: 'done',
        url: `${this.api}a/api/image/downloadByimageId?imageId=${imageId}`,
        response: {
          resultCode: 0,
          data: {
            dataId: dataId,
            imageId: imageId
          }
        }
      })
    },
    setPreviewImgs(imgs) {
      this.previewImgs = []
      this.previewImgs = imgs
      this.showPreviewImgs()
    },
    setPreviewImgOne(img) {
      this.previewImgs = []
      this.previewImgs.push(img)
      this.showPreviewImgs()
    },
    showPreviewImgs() {
      setTimeout(() => {
        this.$refs.previewImgs.$viewer.show()
      }, 500)
    }
  },
  components: {
    emsTitle,
    emsBreadcrumb
  },
  created() {
    this.id = this.$route.query.id
  }

}



// WEBPACK FOOTER //
// ./src/pages/constructionPermit/mixins.js